<div class="modal" (click)="pageClicked($event)">
  <div class="container">
    <div class="content">
      <ng-content></ng-content>
    </div>
    <img class="close-button" src="manager/assets/images/close-info-modal.svg" (click)="closeClicked.emit()">
  </div>
</div>
